module.exports = __webpack_public_path__ + "img/nav.cce99acf.png";